// extracted by extract-css-chunks-webpack-plugin
module.exports = {"window":"window_yqzap"};